import React, { useEffect, useState } from 'react'
import { SnackbarService } from '../../services/snackBehaviorSubject/snackBehaviorSubject';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';
import InfoIcon from '@mui/icons-material/Info';

interface snackBarWidgetProps {
    data: {
        open: boolean,
        severity?: string,
        message?: string
    }
}

const SnackbarWidget = (props: snackBarWidgetProps) => {
    const snackbarService = SnackbarService()
    const [openSnackBar, setOpenSnackBar] = useState({
        open: false,
        severity: 'success',
    })
    const { open, severity } = openSnackBar;
    const [alertText, setAlertText] = useState<string | undefined>('')

    useEffect(() => {
        setOpenSnackBar((preav: any) => ({
            ...preav,
            open: props.data.open,
            severity: props.data.severity || 'success'
        }))
        setAlertText(props.data.message)
    }, [props])

    const handleCloseSnackBar = () => {
        snackbarService?.next({ data: { open: false, message: '' } })
    }

    const getIcon = () => {
        switch (severity) {
            case 'success': return <CheckCircleIcon color="success" sx={{ fontSize: 50, marginBottom: '10px' }} />;
            case 'error': return <ErrorIcon color="error" sx={{ fontSize: 50, marginBottom: '10px' }} />;
            case 'warning': return <WarningIcon color="warning" sx={{ fontSize: 50, marginBottom: '10px' }} />;
            default: return <InfoIcon color="info" sx={{ fontSize: 50, marginBottom: '10px' }} />;
        }
    }

    return (
        <Dialog
            open={open}
            onClose={handleCloseSnackBar}
            PaperProps={{
                style: {
                    minWidth: '350px',
                    textAlign: 'center',
                    padding: '20px',
                    borderRadius: '12px'
                }
            }}
        >
            <DialogContent style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                {getIcon()}
                <Typography variant="h6" style={{ fontWeight: '500', color: '#333' }}>
                    {alertText}
                </Typography>
            </DialogContent>
            <DialogActions style={{ justifyContent: 'center' }}>
                <Button 
                    variant="contained" 
                    onClick={handleCloseSnackBar} 
                    color={severity === 'error' ? 'error' : (severity === 'success' ? 'success' : 'primary')}
                    style={{ minWidth: '100px', borderRadius: '8px' }}
                >
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default SnackbarWidget
